export enum DrivingButtonColors {
  TURNED_OFF = "GRAY",
  READY = "ORANGE",
  DRIVE = "GREEN",
  ERROR = "RED",
}
